import { firebaseDb } from "../core/firebase";

const intercomBoot = (user) => {
  if (user) {
    let premSnapshot = false;
    let userSnapshot = false;

    const last = () => {
      if (!premSnapshot || !userSnapshot) {
        return;
      }
      const premium = premSnapshot.val();
      const userInfo = userSnapshot.val();
      // eslint-disable-next-line new-cap
      window.Intercom("boot", {
        app_id: "jum35ep1",
        name: userInfo.displayName, // Full name
        user_id: userInfo.uid,
        email: userInfo.email, // Email address
        created_at: userInfo.joined, // Signup date
        user_hash: userInfo.userHash,
        is_premium: premium,
      });
    };

    const premiumRef = firebaseDb.ref(`/user/${user.uid}/premium`);
    premiumRef.on("value", (snapshot) => {
      premSnapshot = snapshot;
      last();
    });

    const userRef = firebaseDb.ref(`/user/${user.uid}/info`);
    userRef.on("value", (snapshot) => {
      userSnapshot = snapshot;
      last();
    });

    return;
  }

  // eslint-disable-next-line new-cap
  window.Intercom("boot", {
    app_id: "jum35ep1",
  });
};

export default intercomBoot;



/** WEBPACK FOOTER **
 ** ./src/lib/intercomBoot.js
 **/